// extracted by mini-css-extract-plugin
export var container = "styles-module--container--30f20";
export var space = "styles-module--space--087b6";
export var tags = "styles-module--tags--07657";